import React, { Component, Fragment } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Button from '../../site/Button/Button'
import ButtonLink from '../../site/Button/ButtonLink'
import Input from '../../site/InputFloatingLabel'
import Modal from '../../Modal'
import Picture from '../../Picture'
import RDGateway from '../../../gateways/RDGateway'

import './RequestContact.scss'

const FIELDS = ['name', 'email', 'phone', 'company', 'needs']

const ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
}

const USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
}

class RequestContactv3 extends Component {
    static propTypes = {
        className: PropTypes.string,
        color: PropTypes.string,
        radius: PropTypes.string,
    }

    static defaultProps = {
        radius: 'half-rounded',
    }

    constructor(props) {
        super(props)

        this.rdGateway = new RDGateway()
        this.state = this.getInitialState(props)
    }

    getInitialState(props) {
        const initialObject = {
            showDemoModal: false,
            showDemoForm: false,
            name: '',
            email: '',
            phone: '',
            erp: '',
            needs: '',
            users: '',
            activity: '',
            company: '',
            typingTimeout: 0,
        }

        FIELDS.forEach(campo => {
            initialObject[`${campo}Error`] = false
            initialObject[`${campo}Typing`] = false
        })

        return initialObject
    }

    openDemoModal(e) {
        e.preventDefault()

        this.setState({
            showDemoModal: true,
            showDemoForm: true
        })
    }

    closeDemoModal() {
        this.setState({
            showDemoModal: false,
            showDemoForm: false
        })
    }

    handleChange(e) {
        let stateKey;
        const targetId = e.target.id;
        let value = e.target.value;

        if (targetId.includes('-field')) {
            stateKey = targetId.substring(0, targetId.indexOf('-field'));
        } else if (targetId === 'email') {
            stateKey = 'email';
        } else if (targetId === 'telephone') {
            stateKey = 'phone';
        } else {
            stateKey = targetId;
        }

        if (stateKey === 'phone') {
            value = this.phoneMask(value)
        }

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout)
        }

        this.setState({
            [stateKey]: value,
            [`${stateKey}Error`]: false,
            [`${stateKey}Typing`]: true,
            typingTimeout: setTimeout(() => {
                if (stateKey === 'email' && this.validateEmail(this.state.email)) {
                }
            }, 3000)
        })
    }

    handlerEnterpriseActivity(tipo) {
        this.setState({ 'activity': tipo })
    }

    getSelectedActivity(selected) {
        return this.state.activity === selected ? 'active' : ''
    }

    handlerUsers(tipo) {
        this.setState({ 'users': tipo })
    }

    getSelectedUsers(selected) {
        return this.state.users === selected ? 'active' : ''
    }

    handleActivityDropdownClick = (e) => {
        const dropdown = e.currentTarget.nextElementSibling;
        const button = e.currentTarget;

        dropdown.classList.toggle('show');
        button.classList.toggle('expanded');
    }

    handleActivityOptionClick = (activity) => {
        const button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
        const dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

        dropdown.classList.remove('show');
        button.classList.remove('expanded');
        button.classList.add('option-selected');
        button.textContent = activity;

        this.handlerEnterpriseActivity(activity);
    }

    validation() {
        const newState = {}

        const regexPhone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/
        FIELDS.forEach(campo => {
            newState[`${campo}Error`] = !this.state[campo]
            switch (campo) {
                case 'email': {
                    newState[`${campo}Error`] = !this.validateEmail(this.state[campo])
                    break
                }
                case 'phone': {
                    newState[`${campo}Error`] = !regexPhone.test(this.state[campo])
                    break
                }
            }
        })
        this.setState(newState)
        const lista = Object.values(newState)
        return lista.every(value => (!value))
    }

    validateEmail(email) {
        const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(email.toLowerCase())
    }

    phoneMask(value) {
        var cleanPhone = value ? value.replace(/\D/g, "") : '',
            numberLength = cleanPhone.length

        if (numberLength > 10) {
            cleanPhone = cleanPhone.slice(0, 7) + '-' + cleanPhone.slice(7)
        } else if (numberLength > 6 && numberLength < 11) {
            cleanPhone = cleanPhone.slice(0, 6) + '-' + cleanPhone.slice(6)
        }

        if (numberLength > 2) {
            cleanPhone = cleanPhone.slice(0, 2) + ') ' + cleanPhone.slice(2)
        }

        if (numberLength > 0) {
            cleanPhone = '(' + cleanPhone.slice(0)
        }

        return cleanPhone
    }

    submitForm(e) {
        e.preventDefault()
        if (this.validation()) {
            const data = {
                conversion_identifier: 'canais-lp',
                'cf_tipo_de_conversao': 'Solicitou demonstração',
                name: this.state.name,
                email: this.state.email,
                company_name: this.state.company,
                personal_phone: this.state.phone,
                'cf_atividade_da_empresa': this.state.activity,
                'cf_numero_de_vendedores': this.state.users,
                cf_observacoes: this.state.needs || '',
                cf_carteira_clientes_canais: this.props.portifolioOwner || '',
                'cf_codigo_do_parceiro_meus_pedidos': this.props.partnerId,
                'cf_nome_do_parceiro_canais1': this.props.partnerName,

            }


            this.rdGateway.sendToRDStation(data)

            this.setState({
                showDemoForm: false
            })

            setTimeout(() => {
                this.setState({
                    showDemoModal: false,
                    showDemoForm: true
                })
            }, 3000)
        }
    }

    getDemoModal() {
        return (
            <Modal callbackCloseModal={() => this.closeDemoModal()}>
                <div className={cx('new-form-floating-inputs', this.state.showDemoForm ? '' : 'hide')}>
                    <div className='new-form'>
                        <p className="new-form-title">Solicite uma demonstração</p>
                        <p className="new-form-subtitle">Um de nossos consultores entrará em contato.</p>
                        <form action='.' method='POST' className='new-form' onSubmit={e => this.submitForm(e)}>

                            <Input id='name-field' value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus placeholder={'Nome'} />

                            <Input id='email' value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder={'E-mail'} />

                            <Input id='telephone' value={this.state.phone} onChange={e => this.handleChange(e)} error={this.state.phoneError} maxLength="15" placeholder={'Telefone'} />

                            <Input id='company-field' value={this.state.company} onChange={e => this.handleChange(e)} error={this.state.companyError} placeholder={'Empresa'} />

                            <div className="activity-wrapper">
                                <div className="activity-dropdown-button" onClick={this.handleActivityDropdownClick}>
                                    &nbsp;
                                </div>
                                <div className="activity-dropdown">
                                    <Button className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handleActivityOptionClick(ACTIVITY.industria)}><Picture src="/images/icon-industrias.svg" />Indústrias</Button>
                                    <Button className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handleActivityOptionClick(ACTIVITY.distribuicao)}><Picture src="/images/icon-distribuidoras.svg" />Distribuidoras</Button>
                                    <Button className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handleActivityOptionClick(ACTIVITY.rep)}><Picture src="/images/icon-representates.svg" />Representantes</Button>
                                    <Button className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handleActivityOptionClick(ACTIVITY.outra)}><Picture src="/images/icon-outros.svg" />Outra</Button>
                                </div>
                                {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                                <span className='floating-label'>
                                    Qual é a atividade da sua empresa?
                                </span>
                                <div className="wrapper-input-vendedores">
                                    <p className='label'>Qual é o número de vendedores da sua empresa?</p>
                                    <div className={'group-buttons'}>
                                        <Button model='outline' className={this.getSelectedUsers(USERS.um)} onClick={() => this.handlerUsers(USERS.um)}>1</Button>
                                        <Button model='outline' className={this.getSelectedUsers(USERS.cinco)} onClick={() => this.handlerUsers(USERS.cinco)}>2-5</Button>
                                        <Button model='outline' className={this.getSelectedUsers(USERS.vinte)} onClick={() => this.handlerUsers(USERS.vinte)}>6-20</Button>
                                        <Button model='outline' className={this.getSelectedUsers(USERS.cinquenta)} onClick={() => this.handlerUsers(USERS.cinquenta)}>21-50</Button>
                                        <Button model='outline' className={this.getSelectedUsers(USERS.cinquentaum)} onClick={() => this.handlerUsers(USERS.cinquentaum)}>51 ou mais</Button>
                                        {this.state.usersError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                                    </div>
                                </div>

                            </div>

                            <textarea id='needs-field' defaultValue={this.state.needs} onChange={e => this.handleChange(e)} placeholder='Observações'></textarea>

                            <div className='submit-demo-modal'>
                                <Button type='submit' radius={this.props.radius} className={this.props.className}>SOLICITAR DEMONSTRAÇÃO</Button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className={cx('container-form-confirm', !this.state.showDemoForm ? '' : 'hide')}>
                    <Picture className='success-icon' src='/images/success.png' alt='Solicitação enviada com sucesso!' />
                    <p className='paragraph'>Sua solicitação foi enviada com sucesso!</p>
                </div>
            </Modal>
        )
    }

    render() {
        return (
            <Fragment>
                <div className="new-form-wrapper">
                    <a
                        href='.'
                        className="new-button button-primary button-cta"
                        onClick={e => this.openDemoModal(e)}
                    >
                        {this.props.children || 'peça uma demonstração'}
                    </a>
                    {this.state.showDemoModal && this.getDemoModal()}</div>

            </Fragment>
        )
    }
}

export default RequestContactv3



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/marketplace/Modal/RequestContactv3.jsx